import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CustomInput from 'components/customInput';
import { useRouter } from 'next/router';
import React from 'react';

interface ITechs {
  icon: any;
  placeholder: string;
  title: string;
  titleFr: string;
  name: string;
  value: string;
}

const Item = styled(Paper)({
  '&:hover': {
    boxShadow: '0 15px 25px 0 rgba(0,0,0,0.1)',
    background: 'rgba(255, 255, 255, 0.1)',
  },
});

const Techs = ({ icon, placeholder, title, titleFr, name, value }: ITechs) => {
  const { locale } = useRouter();
  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row" alignItems="center">
        {icon}
        <Typography variant="h6" color="primary">
          {locale === 'fr' ? titleFr : title}
        </Typography>
      </Stack>
      <CustomInput
        placeholder={placeholder}
        name={name}
        value={value}
        rows={3}
      />
    </Stack>
  );
};

export const TechsViewMode = ({
  icon,
  placeholder,
  title,
  titleFr,
  name,
  value,
}: ITechs) => {
  const { locale } = useRouter();
  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row" alignItems="center">
        {icon}
        <Typography variant="h6" color="primary">
          {locale === 'fr' ? titleFr : title}
        </Typography>
      </Stack>
      {value?.split(',').map((el, i) => (
        <Stack direction="row" alignItems="center" key={el}>
          <HorizontalRuleIcon sx={{ mr: 2 }} />{' '}
          <Typography color="text.secondary">{el}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default Techs;
